import { render, staticRenderFns } from "./licitacoes.vue?vue&type=template&id=25c8b310&scoped=true"
import script from "./licitacoes.ts?vue&type=script&lang=ts&external"
export * from "./licitacoes.ts?vue&type=script&lang=ts&external"
import style0 from "./licitacoes.vue?vue&type=style&index=0&id=25c8b310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8b310",
  null
  
)

export default component.exports